<ng-template #content let-modal>
  <div class="content-modal">
    <div class="modal-header d-flex justify-content-center">
      <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-body d-flex justify-content-center">
      <div>
        <div class="center-content-items">
          <img
            src="../../../../assets/img/check-icon.svg"
            class="margin-content-items"
          />
          <p class="margin-content-items text-center" style="line-height: 22px">
            {{ message }}
          </p>
        </div>
        <div
          class="col-sm-12 d-flex justify-content-center align-items-baseline margin-content-items"
        >
          <input type="checkbox" (change)="onCheckBoxChange($event)" />
          <label style="margin: 2px 0 5px 10px">
            {{
              lextranslate.i18n["2528d076-f758-4422-a9e5-9249020bd790"] + "!"
            }}
          </label>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button
        type="button"
        class="btn btn-success"
        (click)="modal.close('Close click')"
      >
        {{ buttonMessage }}
      </button>
    </div>
  </div>
</ng-template>
